import React from 'react';
import PropTypes from 'prop-types';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';

import RadioButton from '../RadioButton';

const RadioButtons = ({
  inline,
  label,
  labelPlacement,
  name,
  onChange,
  radios,
  value,
}) => (
  <div>
    { label && <FormLabel>{label}</FormLabel> }
    <RadioGroup
      style={inline ? { flexDirection: 'row' } : {}}
      name={name}
      value={value}
      onChange={onChange}
    >
      { radios.map(({ label: radioLabel, value: radioValue }) => (
        <FormControlLabel
          key={`radio-${radioValue}`}
          value={radioValue}
          label={radioLabel}
          labelPlacement={labelPlacement}
          control={<RadioButton />}
        />
      ))}
    </RadioGroup>
  </div>
);

RadioButtons.propTypes = {
  inline: PropTypes.bool,
  label: PropTypes.object,
  labelPlacement: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  radios: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]).isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  value: PropTypes.string.isRequired,
};

RadioButtons.defaultProps = {
  inline: false,
  label: null,
  labelPlacement: 'end',
};

export default RadioButtons;
